<template>

    <Page>

        <h2 class="mb-4 text-2xl 2xl:text-3xl font-semibold">We followed the clues!</h2>

        <p class="text-xl 2xl:text-2xl text-justify font-normal text-white/80 max-w-[80%]">
            We examined the markets around the world, to uncover the best strategies for boosting 
            customer retention - identifying <span class="text-emerald-500 font-semibold">emerging trends</span>, and understanding 
            where the <span class="text-emerald-500 font-semibold">future of automotive</span> is headed.
        </p>

        <p class="text-xl 2xl:text-2xl text-justify font-normal text-white/80 mt-3 max-w-[80%]">
            From global leaders to cutting-edge disruptors, we've studied <span class="text-emerald-500 font-semibold"> what works
             — and what's next</span>. Now we're bringing that insight home.
        </p>

    </Page>

</template>